import { RadioProgramJsonItem } from "../../../../jsonSerializer/radioScheduleJsonSerializer"
import { YnetLiveFloatingPlayer } from "./ynetLiveFloatingPlayer";
import { YnetLiveAudioPlayButton, AudioRendererProps } from "./ynetLiveAudioPlayButton";
import { AdsProgressBar } from "./adProgressBar";
import { FloatingVideoLivePlayer } from "../../../../siteWidgets/videoPlayer/genericInlineVideoPlayer/floatingVideoLivePlayer/floatingVideoLivePlayer";
import { isWcmEditor } from "../../../../../config/serverConfig";
import { buildAdTag } from "../../../radioWidgets/floatingPlayer/imaAdTagBuilder";
import * as ResizeObserver from "resize-observer-polyfill"
import { getTranslation } from "../translations";

const HLS_LOADED_EVENT = "hls_lodaed";

export interface RadioProgramItem extends Partial<RadioProgramJsonItem> {
    startTime: string
    endTime: string
}

export interface YnetLiveComponentaProps {
    isMobileWeb: boolean
    programTitle: string
    liveBroadcastSource: string
    floatingVideoLivePlayerSource: string
    lang?: string
    hideYnetLive?:boolean
}

interface YnetLiveComponentaState {
    isAdPlaying: boolean
    isVideoFloatingPlayerVisible: boolean
    isHlsLoaded: boolean
    isHlsLoadingError: boolean
    floatingPlayerBottomHeight: number
    isTitleOverFlowing: boolean
   
   
}
const MUTAM_SCREEN_WIDTH = 640;

export class YnetLiveComponenta extends React.Component<YnetLiveComponentaProps, YnetLiveComponentaState> {
    public static siteScriptName = "YnetLiveComponenta"

    constructor(props) {
        super(props)
        this.state = {
            isAdPlaying: false,
            isVideoFloatingPlayerVisible: false,
            isHlsLoaded: false,
            isHlsLoadingError: false,
            floatingPlayerBottomHeight: 0,
            isTitleOverFlowing:null
        }
        if (!isWcmEditor() && typeof window !== 'undefined' && !document.getElementById("hlsjsscript")) {
            const script = document.createElement('script')
            script.id = "hlsjsscript"
            script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.2.3'
            script.onload = () => document.dispatchEvent(new CustomEvent(HLS_LOADED_EVENT));
            script.onerror = this.updateHlsLoadError
            document.head.appendChild(script)
        }
    }

    private resizeObserver: ResizeObserver;

    componentDidMount() {
        document.addEventListener(HLS_LOADED_EVENT, this.updateHlsLoaded);

        const elementId = this.props.isMobileWeb ? "ads.banner" : "ads.sargel"
        const stickyAdElement = document.getElementById(elementId)
        this.resizeObserver = new ResizeObserver(records => records.forEach(r => {
            this.onContentHeightChanged(r.contentRect.height)
        }))
        stickyAdElement && this.resizeObserver.observe(stickyAdElement);
    }

    componentWillUnmount() {
        document.removeEventListener(HLS_LOADED_EVENT, this.updateHlsLoaded)
        this.resizeObserver && this.resizeObserver.disconnect()
    }

    private onContentHeightChanged = (height: number) => {
        this.setState({ floatingPlayerBottomHeight: height })
    }

    private updateHlsLoaded = () => {
        this.setState({ isHlsLoaded: true })
    }

    private updateHlsLoadError = () => {
        this.setState({ isHlsLoadingError: true })
    }

    private onAdPlayingStateChange = (isAdPlaying) => {
        this.setState({ isAdPlaying })
    }

    private onVideoFloatingPlayerClose = () => {
        this.setState({ isVideoFloatingPlayerVisible: false });
    }



    private calculateIsTitleOverFlowing = (ref: HTMLDivElement) => {
         if (ref) {
            const wrapperElement = document.querySelector(".program-title-wrapper") as HTMLElement
            const titleOverflow = wrapperElement ? ref.offsetWidth > wrapperElement.offsetWidth : false
            this.setState({
                isTitleOverFlowing: titleOverflow,
            });
        }
    }
    render() {
        const { isMobileWeb, liveBroadcastSource, programTitle, floatingVideoLivePlayerSource, lang, hideYnetLive } = this.props;
        const { isAdPlaying, isVideoFloatingPlayerVisible, floatingPlayerBottomHeight, isTitleOverFlowing } = this.state;
        const browserDisplayMediaMetaData = { title: programTitle, artist: "ynet" };
        const sourceImage = isMobileWeb ? "https://www.ynet.co.il/images/live/mobile.gif" : "https://www.ynet.co.il/images/live/logo.gif";
        const mainTitle = isMobileWeb ? getTranslation(lang, "Listen to the broadcast") : getTranslation(lang, "Now Live");
        const noShowsText = "";
        const adTagUrl = buildAdTag(isMobileWeb);
        const { isHlsLoaded, isHlsLoadingError } = this.state;
        if ((!isHlsLoaded && !isHlsLoadingError) || hideYnetLive) return null;

        return (
            <div className="ynet-live-componenta">
                <img className="main-logo" src={sourceImage} />
                <div className="text-div">
                    <div className="main-title">{mainTitle}</div>
                    <div className="separator"></div>
                  {isMobileWeb ?   <div className="program-title-wrapper">
                    {isTitleOverFlowing ?
                                <>
                            
                                    <div className="slider-wrapper" >                                 
                                            <div className={"program-title"} style={{ "--titleLength":`${programTitle.length*0.2}s`}} key={1} dangerouslySetInnerHTML={{ __html: programTitle || noShowsText }}></div>
                                            <div className={"program-title"} style={{ "--titleLength":`${programTitle.length*0.2}s`}} aria-hidden   key={2} dangerouslySetInnerHTML={{ __html: programTitle || noShowsText }}></div>        
                                    
                                    </div>
                                   
                                </> :
                                <div className={"program-title"} ref={this.calculateIsTitleOverFlowing} dangerouslySetInnerHTML={{ __html: programTitle || noShowsText }}></div>
                            }</div> :  <div className="program-title"  dangerouslySetInnerHTML={{ __html: programTitle || noShowsText }}></div>}

                    </div>

                {isMobileWeb ?
                    <YnetLiveAudioPlayButton
                        audioUrl={liveBroadcastSource}
                        durationSeconds={0}
                        shouldAppearOnComponentOutOfView={true}
                        browserDisplayMediaMetaData={browserDisplayMediaMetaData}
                        isAdPlaying={isAdPlaying}
                        adTag={adTagUrl}
                        onAdPlayingStateChange={this.onAdPlayingStateChange}
                        onVideoFloatingPlayerClose={this.onVideoFloatingPlayerClose}
                        programTitle={programTitle}
                        lang={lang}
                        isVideoFloatingPlayerVisible={isVideoFloatingPlayerVisible}
                        renderer={(props: AudioRendererProps) => (<YnetLiveRadioMobileWeb {...props} />)}
                        floatingPlayerRenderer={(rendererProps) => (
                            <YnetLiveFloatingPlayer
                                isMobileWeb={isMobileWeb}
                                isAudioPlaying={rendererProps.isAudioPlaying}
                                isFloatingPlayerVisible={isVideoFloatingPlayerVisible ? false : rendererProps.isFloatingPlayerVisible}
                                onTogglePlayPause={rendererProps.onTogglePlayPause}
                                onClose={rendererProps.onClose}
                                title={programTitle}
                                lang={lang}
                                floatingPlayerBottomHeight={floatingPlayerBottomHeight}
                            >
                                <AdsProgressBar
                                    adDuration={rendererProps.adDuration}
                                    adPlaybackTime={rendererProps.adPlaybackTime}
                                    isAdPlaying={isAdPlaying}
                                    lang={lang} />
                            </YnetLiveFloatingPlayer>)}
                    />
                    :
                    <div className="buttons-div">
                        <button className="video-button btn" onClick={() => this.setState({ isVideoFloatingPlayerVisible: true })}>{`${getTranslation(lang, "Watch")} >`}</button>
                        <YnetLiveAudioPlayButton
                            audioUrl={liveBroadcastSource}
                            durationSeconds={0}
                            shouldAppearOnComponentOutOfView={true}
                            browserDisplayMediaMetaData={browserDisplayMediaMetaData}
                            isAdPlaying={isAdPlaying}
                            adTag={adTagUrl}
                            lang={lang}
                            onAdPlayingStateChange={this.onAdPlayingStateChange}
                            onVideoFloatingPlayerClose={this.onVideoFloatingPlayerClose}
                            programTitle={programTitle}
                            isVideoFloatingPlayerVisible={isVideoFloatingPlayerVisible}
                            renderer={(props: AudioRendererProps) => (<YnetLiveRadio {...props} />)}
                            floatingPlayerRenderer={(rendererProps) => (
                                <YnetLiveFloatingPlayer
                                    isMobileWeb={isMobileWeb}
                                    isAudioPlaying={rendererProps.isAudioPlaying}
                                    isFloatingPlayerVisible={isVideoFloatingPlayerVisible ? false : rendererProps.isFloatingPlayerVisible}
                                    onTogglePlayPause={rendererProps.onTogglePlayPause}
                                    onClose={rendererProps.onClose}
                                    title={programTitle}
                                    lang={lang}
                                    floatingPlayerBottomHeight={floatingPlayerBottomHeight}
                                >
                                    <AdsProgressBar
                                        adDuration={rendererProps.adDuration}
                                        adPlaybackTime={rendererProps.adPlaybackTime}
                                        isAdPlaying={isAdPlaying}
                                        lang={lang}/>
                                </YnetLiveFloatingPlayer>)}
                        />
                        {this.state.isVideoFloatingPlayerVisible &&
                            <div className="live-video-floating-player">
                                <FloatingVideoLivePlayer videoSource={floatingVideoLivePlayerSource} isYnetLive={true} onClose={this.onVideoFloatingPlayerClose} />
                            </div>
                        }
                    </div>}
            </div>
        )
    }
}

function YnetLiveRadio({ isAudioPlaying, onTogglePlayPause, lang }: AudioRendererProps) {
    const buttonClass = `audio-button btn ${isAudioPlaying ? "pause" : "play"}`;
    return (
        <button className={buttonClass} onClick={onTogglePlayPause}>{`${getTranslation(lang, "Listen")} >`}</button>
    );
}

function YnetLiveRadioMobileWeb({ isAudioPlaying, onTogglePlayPause }: AudioRendererProps) {
    const buttonClass = `media-button ${isAudioPlaying ? "pause" : "play"}`;
    return (
        <div className={buttonClass} onClick={onTogglePlayPause}></div>
    );
}